import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../../context/TranslateContext";
import {AuthContext} from "../../../context/AuthContext";
import {RuoliContext} from "../../../context/RuoliContext";
import {
    aggiornaKpiApi, aggiungiKpiApi, aggiungiKpiControlloApi, aggiungiStrutturaKpiApi, caricaTemplateKpiApi,
    getControlliKpiApi,
    getKpiByIdApi,
    getListaKpiApi,
    getStrutturaKpiApi, getTipiKpiApi,
    rimuoviRelazioneKpiControlloApi, rimuoviStrutturaKpiApi
} from "../services/KpiServices";
import {getFrequenzeApi} from "../../frequenze/services/FrequenzeServices";
import ModificaKpiView from "./ModificaKpiView";
import {getMacrocategorieApi} from "../../macrocategorie/services/MacrocategorieServices";
import {getClassiTipiImpExpDatiApi} from "../../tipi_imp_exp_dati/services/TipiImpExpDatiServices";
import {ParametersContext} from "../../../context/ParametersContext";

export default function ModificaKpiController() {
    const {id} = useParams()

    const [idKpi, setIdKpi] = useState(id);
    const [loadingData, setLoadingData] = useState(true);
    const [loadingTabelle, setLoadingTabelle] = useState(true);
    const [configurato, setConfigurato] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [frequenze, setFrequenze] = useState([]);
    const [tipi, setTipi] = useState([]);
    const [macrocategorie, setMacrocategorie] = useState([]);
    const [strutturaKpi, setStrutturaKpi] = useState([]);
    const [relkpiChecks, setRelkpiChecks] = useState([]);
    const [optionsKpiChecks, setOptionsKpiChecks] = useState([]);
    const [kpiCheckSel, setKpiCheckSel] = useState();
    const [showConfirmKpiCheckDel, setShowConfirmKpiCheckDel] = useState(false);
    const [template, setTemplate] = useState();
    const [tabella, setTabella] = useState();
    const [tipiKpi, setTipiKpi] = useState([]);

    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);
    const {annoKpi} = useContext(AuthContext);
    const {isRuoloSuperAdmin} = useContext(RuoliContext);
    const {getParameterValue} = useContext(ParametersContext);

    const formikRef = useRef();
    const formikRefTabella = useRef();
    const formikRefTemplate = useRef();
    const formikRefChecks = useRef();
    const history = useHistory();

    const statiKpi = [{
        id: 1,
        descrizione: translate("Attivo")
    }, {
        id: 0,
        descrizione: translate("Non attivo")
    }];

    async function getKpi() {
        const response = await getKpiByIdApi(idKpi);
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_kpi", response.data.data.id_kpi || '');
            formikRef.current.setFieldValue("codice", response.data.data.codice || '');
            formikRef.current.setFieldValue("descrizione", response.data.data.descrizione || '');
            formikRef.current.setFieldValue("id_frequenza_compilazione", response.data.data.id_frequenza_compilazione || '');
            formikRef.current.setFieldValue("id_classe_tipo_imp_dati", response.data.data.id_classe_tipo_imp_dati || '');
            formikRef.current.setFieldValue("id_classe_tipo_exp_dati", response.data.data.id_classe_tipo_exp_dati || '');
            formikRef.current.setFieldValue("id_kpi_macrocategoria", response.data.data.id_kpi_macrocategoria || '');
            formikRef.current.setFieldValue("stato", response.data.data.stato || '');
            formikRef.current.setFieldValue("tag", response.data.data.tag || '');
            formikRef.current.setFieldValue("ordine_tag", response.data.data.ordine_tag || '');
            formikRef.current.setFieldValue("ordine", response.data.data.ordine || '');
            formikRef.current.setFieldValue("configurato", response.data.data.configurato || '');
            formikRef.current.setFieldValue("canc", response.data.data.canc || '');
            formikRef.current.setFieldValue("tipo_kpi", response.data.data.tipo_kpi || '');
            formikRef.current.setFieldValue("ordine_exp_dati", response.data.data.ordine_exp_dati || '');
            formikRef.current.setFieldValue("gg_scadenza", response.data.data.gg_scadenza || '');
            formikRef.current.setFieldValue("mm_scadenza", response.data.data.mm_scadenza || '');

            //if ((response.data.data.gg_scadenza || response.data.data.gg_scadenza === 0) || (response.data.data.mm_scadenza || response.data.data.mm_scadenza === 0)) {
            if ((response.data.data.gg_scadenza === 0) || (response.data.data.mm_scadenza === 0)) {
                let paramCode = 'GiornoDefInScadenza,MeseDefInScadenza';
                getParametriInScadenza(paramCode);
            }

            setConfigurato(response.data.data.configurato == '1');
        }
    }

    async function getOptionsKpiChecks() {
        const response = await getListaKpiApi('?tipo_kpi=2');
        setOptionsKpiChecks(response.data.data);
    }

    async function getRelKpiChecks() {
        const response = await getControlliKpiApi(idKpi);
        setRelkpiChecks(response.data.data);
    }

    async function getStrutturaKpi() {
        const response = await getStrutturaKpiApi(idKpi);
        setStrutturaKpi(response.data.data);
        setLoadingTabelle(false);
    }

    async function getFrequenze() {
        const response = await getFrequenzeApi();
        setFrequenze(response.data.data);
    }

    async function getTipi() {
        const response = await getClassiTipiImpExpDatiApi()
        setTipi(response.data.data);
    }

    async function getMacrocategorie() {
        const response = await getMacrocategorieApi();
        setMacrocategorie(response.data.data);
    }

    async function getTipiKpi() {
        const response = await getTipiKpiApi();
        setTipiKpi(response.data.data);
    }

    async function getParametriInScadenza() {
        formikRef.current.setFieldValue('gg_scadenza', await getParameterValue('GiornoDefInScadenza'));
        formikRef.current.setFieldValue('mm_scadenza', await getParameterValue('MeseDefInScadenza'));
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            if (loadingData) {
                getFrequenze();
                getTipi();
                getMacrocategorie();
                getOptionsKpiChecks();
                getTipiKpi();
            }
            if (idKpi && idKpi !== '') {
                getKpi();
                getStrutturaKpi();
                getRelKpiChecks();
            } else {
                getParametriInScadenza();
            }
        }
    }, [lingua, annoKpi, idKpi, loadingNewLang]);

    const SignupSchema = Yup.object().shape({
        codice: Yup.string()
            .max(25, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        id_frequenza_compilazione: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        ordine: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        stato: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        tipo_kpi: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        gg_scadenza: Yup.string()
            .required(translate('Questo campo è obbligatorio')).nullable(),
        mm_scadenza: Yup.string()
            .required(translate('Questo campo è obbligatorio')).nullable()
    });

    const SignupSchemaTemplate = Yup.object().shape({
        file: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
    });

    async function rimuoviRelazioneKpiControllo() {
        const response = await rimuoviRelazioneKpiControlloApi(idKpi, kpiCheckSel.id_rel_kpi_check);
        setRelkpiChecks(response.data.data);
    }

    async function aggiornaKpi(values) {
        const response = await aggiornaKpiApi(idKpi, values);
        if (response.data.result === 0) {
            // history.goBack();
            getKpi();
            getStrutturaKpi();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiKpi(values) {
        const response = await aggiungiKpiApi(values);
        if (response.data.result === 0) {
            // history.goBack();
            setIdKpi(response.data.data.id_kpi);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function rimuoviStrutturaKpi() {
        const response = await rimuoviStrutturaKpiApi(idKpi);
        if (response.data.result === 0) {
            // history.goBack(); // TODO
            getKpi();
            getStrutturaKpi();
            setTabella();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiStrutturaKpi() {
        const response = await aggiungiStrutturaKpiApi(idKpi, tabella);
        if (response.data.result === 0) {
            getStrutturaKpi();
            setConfigurato(true);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function caricaTemplateKpi(formData) {
        const response = await caricaTemplateKpiApi(idKpi, formData);
        if (response.data.result === 0) {
            // history.goBack();// TODO
            setTabella(response.data.data)
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiKpiControllo(values) {
        let rel = {
            id_kpi_check: values.id_kpi_check,
            id_kpi: id
        };

        const response = await aggiungiKpiControlloApi(idKpi, rel);
        if (response.data.result === 0) {
            setRelkpiChecks(response.data.data);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function handleConfirmEliminaRelazioneKpi() {
        setShowConfirmKpiCheckDel(false);
        rimuoviRelazioneKpiControllo();
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialValuesKpi = {
        id_kpi: '',
        codice: '',
        descrizione: '',
        id_frequenza_compilazione: '1', //*Sara* imposto il valore fisso (come Annuale) e tolgo oggetto
        id_classe_tipo_imp_dati: '',
        id_classe_tipo_exp_dati: '',
        id_kpi_macrocategoria: '',
        stato: '1',
        tag: '',
        ordine_tag: '',
        ordine: '',
        configurato: '0',
        canc: '',
        tipo_kpi: '',
        gg_scadenza: '',
        mm_scadenza: ''
    };

    const initialValuesTemplate = {
        file: '',
    };

    function onSubmitFormKpi(values) {
        if (idKpi) {
            aggiornaKpi(values);
        } else {
            aggiungiKpi(values);
        }
    }

    function onSubmitFormTemplate(values) {
        if (template) {
            const formData = new FormData();
            formData.append("files", template);

            setTabella();
            caricaTemplateKpi(formData);
        }
    }

    return (
        <ModificaKpiView
            show={show}
            translate={translate}
            modalMsg={modalMsg}
            setShow={setShow}
            relkpiChecks={relkpiChecks}
            loadingTabelle={loadingTabelle}
            formikRef={formikRef}
            idKpi={idKpi}
            aggiungiKpiControllo={aggiungiKpiControllo}
            macrocategorie={macrocategorie}
            aggiungiStrutturaKpi={aggiungiStrutturaKpi}
            showConfirmKpiCheckDel={showConfirmKpiCheckDel}
            SignupSchema={SignupSchema}
            isRuoloSuperAdmin={isRuoloSuperAdmin}
            configurato={configurato}
            formikRefChecks={formikRefChecks}
            kpiCheckSel={kpiCheckSel}
            tipi={tipi}
            tipiKpi={tipiKpi}
            statiKpi={statiKpi}
            formikRefTabella={formikRefTabella}
            formikRefTemplate={formikRefTemplate}
            optionsKpiChecks={optionsKpiChecks}
            rimuoviStrutturaKpi={rimuoviStrutturaKpi}
            setKpiCheckSel={setKpiCheckSel}
            setShowConfirmKpiCheckDel={setShowConfirmKpiCheckDel}
            setTemplate={setTemplate}
            strutturaKpi={strutturaKpi}
            tabella={tabella}
            SignupSchemaTemplate={SignupSchemaTemplate}
            handleConfirmEliminaRelazioneKpi={handleConfirmEliminaRelazioneKpi}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialValuesKpi={initialValuesKpi}
            initialValuesTemplate={initialValuesTemplate}
            onSubmitFormKpi={onSubmitFormKpi}
            onSubmitFormTemplate={onSubmitFormTemplate}
            handlerChangeTabella={getStrutturaKpi}
        />
    );
}